export default __webpack_public_path__ + "static/media/btn_close.a4aa9391.svg";